'use client';

import { Typography } from '@coolblue-development/freddy';
import type { Product } from '@features/product/typings';
import { useTranslation } from '@i18n/useTranslation';

export const SubscriptionInformationEntrance = ({ product }: { product: Product }) => {
  const { t } = useTranslation('webshop');

  return (
    <>
      <Typography variant='h2' mb={0}>
        {t('subscriptionInformation.title', {
          productTypeNameSingular: product.productType.singularName
        })}
      </Typography>

      <Typography variant='body' mb={0}>
        {t('subscriptionInformation.body', {
          productTypeNameSingular: product.productType.singularName
        })}
      </Typography>
    </>
  );
};
